import type {
  CurrencySeparatorOption,
  DatatableSettings,
  DatatableSettingsKey,
  SymbolPlacement,
  TagDisplay,
  TagStructure,
} from './datatable.types';

export const TIME_STYLES = ['decimal', 'digital', 'traditional'] as const;

export const CURRENCY_SEPARATORS: Array<CurrencySeparatorOption> = [
  'comma-period',
  'period-comma',
  'space-comma',
  'apostrophe-period',
] as const;

export const SYMBOL_PLACEMENTS: Array<{
  value: SymbolPlacement;
  label: string;
}> = [
  { value: 'before', label: 'Before the amount' },
  { value: 'after', label: 'After the amount' },
  { value: 'hidden', label: 'Hide symbol' },
] as const;

export const TAG_STRUCTURE: Array<{
  value: TagStructure;
  label: string;
}> = [
  { value: 'consolidated', label: 'Consolidated tags into one column' },
  { value: 'separate', label: 'Separate tags into multiple columns' },
] as const;

export const TAG_DISPLAY: Array<{
  value: TagDisplay;
  label: string;
}> = [
  { value: 'tags', label: 'Tags' },
  { value: 'tagLists', label: 'Tag lists' },
  { value: 'listsAndTags', label: 'Tag lists & tags' },
] as const;

export const DEFAULT_DATATABLE_SETTINGS: DatatableSettings = {
  zebraStripes: { value: false },
  verticalBorders: { value: false },
  timeStyle: { value: 'traditional' },
  currencyFormat: {
    value: {
      separator: 'comma-period' as CurrencySeparatorOption,
      symbolPlacement: 'before',
    },
  },
  tagStyle: {
    value: {
      tagStructure: 'consolidated',
      tagDisplay: 'tags',
    },
  },
  aggregateFunctions: { value: {} },
} as const;

export const DEFAULT_CLIENT_DATATABLE_SETTINGS: DatatableSettings = {
  zebraStripes: { value: false },
  verticalBorders: { value: true },
  timeStyle: { value: 'traditional' },
  currencyFormat: {
    value: {
      separator: 'comma-period' as CurrencySeparatorOption,
      symbolPlacement: 'before',
    },
  },
  aggregateFunctions: { value: {} },
  breakdownType: { value: 'week' },
  interval_value: { value: 'time' },
} as const;

export const DATATABLE_SETTINGS_LABELS: Record<DatatableSettingsKey, string> = {
  zebraStripes: 'Zebra stripes',
  verticalBorders: 'Vertical borders',
  timeStyle: 'Time format',
  currencyFormat: 'Currency format',
  tagStyle: 'Tags display',
  aggregateFunctions: 'Aggregate functions',
  breakdownType: 'Daily breakdown',
  interval_value: 'Value',
} as const;
